module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('static.clients.catalogues.sendCatalogue')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [(_vm.loading) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('v-form', {
    attrs: {
      "save": _vm.save,
      "form": _vm.form,
      "translation": "form.catalogues"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81e3b262","hasScoped":false}!./src/app/components/sendCatalogue/sendCatalogue.html
// module id = 3082
// module chunks = 1